import { MsgExecuteContract } from "cosmes/client"
import { useWallet } from "providers/WalletProvider"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { DENOM, FACTORY_ADDRESS } from "utils/Constants"
import { formatDenom, formatNumber, getSymbol } from "utils/Functions"
import { queryBalance, querySmartContract } from "utils/RpcHelper"

export function RegisterPairPage() {
    const { address: walletAddress, post } = useWallet()
    const [pairAddress, setPairAddress] = useState("")
    const [firstAssetSymbol, setFirstAssetSymbol] = useState("")
    const [secondAssetSymbol, setSecondAssetSymbol] = useState("")
    const [tokenFee, setTokenFee] = useState<string>()
    const [availableFee, setAvailableFee] = useState<{ [key: string]: number }>({})
    const [feeInfos, setFeeInfos] = useState<{ [key: string]: { symbol: string } }>({})
    const navigate = useNavigate()

    const loadConfig = async () => {
        try {
            const { register_fee } = await querySmartContract(FACTORY_ADDRESS, { config: {} })
            for (const key of Object.keys(register_fee)) {
                const { symbol } = await querySmartContract(key, { token_info: {} })
                setFeeInfos(prev => ({ ...prev, [key]: { symbol: symbol } }))
            }
            setAvailableFee(Object.entries(register_fee).reduce((prev, [key, value]) => ({ ...prev, [key]: Number(value) }), {}))
        } catch {
        }
    }

    useEffect(() => {
        loadConfig()
    }, [])

    const loadPairInfo = async () => {
        try {
            const { asset_infos } = await querySmartContract(pairAddress, { pair: {} })
            if (asset_infos) {
                setFirstAssetSymbol(await getSymbol(asset_infos[0]))
                setSecondAssetSymbol(await getSymbol(asset_infos[1]))
            }
        } catch {
            alert("Cannot load pair info")
        }
    }

    useEffect(() => {
        if (pairAddress.length > 0) loadPairInfo()
    }, [pairAddress])

    const register = async () => {
        if (!walletAddress) return alert("Please connect your wallet first")
        if (!pairAddress) return alert("Please enter the pair address")
        if (!tokenFee) return alert("Please select fee option")

        try {
            const registerMsg = {
                register_pair: {
                    pair_address: pairAddress
                }
            };

            let msg = undefined;
            const { is_whitelisted } = await querySmartContract(FACTORY_ADDRESS, { check_whitelist: { pair: pairAddress } })

            if (is_whitelisted == true) {
                alert("Congratulation!!, your pair is whitelisted for free register")

                msg = new MsgExecuteContract({
                    contract: FACTORY_ADDRESS,
                    funds: [],
                    sender: walletAddress,
                    msg: registerMsg
                })
            } else {
                let fee = availableFee[tokenFee]
                const { balance } = await querySmartContract(tokenFee, { balance: { address: walletAddress } })
                if ((!balance) || balance < fee) return alert("Your balance is not enough to pay the fee")

                msg = new MsgExecuteContract({
                    sender: walletAddress,
                    contract: tokenFee,
                    funds: [],
                    msg: {
                        send: {
                            msg: Buffer.from(JSON.stringify(registerMsg)).toString("base64"),
                            contract: FACTORY_ADDRESS,
                            amount: fee.toString()
                        }
                    },
                })
            }

            const txHash = await post({
                msgs: [msg],
                memo: `Register pair ${pairAddress} (${firstAssetSymbol}/${secondAssetSymbol})`
            }, [])

            navigate("/tx-loading/" + txHash)
        } catch (e) {
            console.log(e)
            alert("error: " + e + ", (PLEASE REPORT TO DEVELOPER)")
        }

    }

    return <div className="w-100 p-2 px-4">
        <h4>Register your pair</h4>
        <p className="text-muted">Only for <b>Terraport</b> and <b>TerraSwap</b> pair</p>

        <div className="form-group">
            <label htmlFor="pair-address">Pair Address</label>
            <input
                onChange={({ target }) => setPairAddress(target.value)}
                value={pairAddress}
                type="text"
                className="form-control"
                id="pair-address"
                placeholder="Enter Pair Address" />
        </div>

        <div className="d-flex flex-row">
            <div className="form-group flex-grow-1">
                <label>First Asset</label>
                <span className="form-control">{firstAssetSymbol}</span>
            </div>
            <i className="icon-md mx-3 mt-auto mb-2 mdi mdi-swap-horizontal"></i>

            <div className="form-group flex-grow-1">
                <label>Second Asset</label>
                <span className="form-control">{secondAssetSymbol}</span>
            </div>
        </div>

        {
            Object.entries(availableFee).length > 0 && <div className="form-group">
                <label htmlFor="fee">Fee</label>
                <select
                    onChange={({ target }) => setTokenFee(target.value)}
                    className="form-control"
                    id="pair-address">
                    <option>Select Fee</option>
                    {
                        Object.entries(availableFee).map(([address, amount]) => <option value={address}>{amount / 1e6} {feeInfos[address]?.symbol}</option>)
                    }
                </select>
            </div>
        }



        <button type="button" onClick={register} className="btn btn-primary w-100 btn-lg">Register</button>

    </div>
}